import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseQuery = (isImageApi: boolean = false) =>
    fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        prepareHeaders(headers) {
            const user = localStorage.getItem("userAuth")
                ? JSON.parse(localStorage.getItem("userAuth") as string)
                : null;
            if (!isImageApi) {
                headers.set("Content-Type", "application/json");
            }
            if (user?.access_token) {
                headers.set(
                    "Authorization",
                    `${user.token_type} ${user.access_token}`
                );
            }
            return headers;
        },
    });
